import { cancelToken, setTabContentTo, createCustomEvent } from '../../../../javascript/shared/helpers';

export default class extends Controller {
  static targets = ['tab', 'tabPane', 'initialTabLink', 'iconLink'];

  connect() {
    const urlComponents = document.URL.split('#');
    const anchor = this.anchor || (urlComponents.length > 1 && urlComponents[urlComponents.length - 1]);
    this.initialTabLinkTarget && this.setTabContent(this.initialTabLinkTarget, anchor);
    App.Helpers.listenToCustomEvent(document, 'update-success', this.reloadTabContentAfterModalFormSubmit.bind(this));
    this.setTooltipPlacement = this.setTooltipPlacement.bind(this);
    if (this.hasIconLinkTarget) {
      this.setTooltipPlacement();
      window.addEventListener('resize', this.setTooltipPlacement);
    }
  }

  disconnect() {
    window.removeEventListener('resize', this.setTooltipPlacement);
  }

  setNewTabContent(event) {
    event && event.preventDefault();
    this.setTabContent(event.currentTarget);
  }

  async setTabContent(tab, anchor=null) {
    this.setAndCancelToken();
    this.activeTab = tab.dataset.tabId;
    const res = await setTabContentTo({
      tab,
      anchor,
      container:            this.container,
      target:               this.tabPaneTarget,
      url:                  tab.dataset.url,
      cancelToken:          this.cancelToken,
      pushState:            this.pushState,
      executeBeforeTabLoad: this.executeBeforeTabLoad
    });
    document.dispatchEvent(createCustomEvent('tab-load-success', this.element));
  }

  setAndCancelToken() {
    this.cancelToken && this.cancelToken.cancel('New Tab clicked...');
    this.cancelToken = cancelToken();
  }

  setTooltipPlacement() {
    this.iconLinkTargets.forEach(link => {
      $(link).tooltip('destroy');
      $(link).tooltip({ trigger: "hover", placement: window.innerWidth >= 1024 ? 'right' : 'top' });
    });
  }

  //
  // INTERNAL USE
  //

  reloadTabContentAfterModalFormSubmit(event) {
    event && event.detail.reloadTab && this.setTabContent(this.activeTab);
  }

  //
  // GETTERS AND SETTERS
  //

  get activeTab() {
    return this.tabTargets.find(tab => tab.dataset.tabId == this.data.get('active-tab'));
  }

  set activeTab(val) {
    return this.data.set('active-tab', val);
  }

  get pushState() {
    return [true, "true", 1, "1"].includes(this.data.get("push-state"));
  }

  get anchor() {
    return this.data.get("anchor");
  }

  get container() {
    return this.containerSelector ? document.querySelector(this.containerSelector) : window;
  }

  get containerSelector() {
    return this.data.get("container-selector")
  }

  get executeBeforeTabLoad() {
    return ["1", 1, true, "true"].includes(this.data.get("execute-before-tab-load"))
  }
};



// WEBPACK FOOTER //
// ./app/components/tabs/assets/javascript/activity-tabs-controller.js